module.exports = fox._r("fonts/tags-filter.svg?3lzqzp", __webpack_public_path__ + "_/_/_/root/fonts/tags-filter.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/tags-filter.svg?3lzqzp
// module id = 426
// module chunks = 4